import {Directive, HostListener} from '@angular/core';
import {NgControl} from '@angular/forms';
import {replace} from 'lodash';

@Directive({
  selector: '[appNoSpaces]'
})
export class NoSpacesDirective {
  constructor(private control: NgControl) {
  }

  @HostListener('keydown.space', ['$event'])
  onInput(event: any): void {
    event.preventDefault();
  }

  @HostListener('paste', ['$event'])
  onPaste(event: any): void {
    const data = event.clipboardData.getData('text');
    this.control.reset(replace(data, new RegExp(/\s/g), ''));
    this.control.control.markAsDirty();
    event.preventDefault();
  }
}
